import React from 'react';
import IndustryPageTemplate from './IndustryPageTemplate';

const pageData = {
  seo: {
    title: 'Custom Fitness & Gym Management Software | RojrzTech',
    description: 'Elevate your fitness business with custom member portals, automated billing, class scheduling, and personalized coaching platforms designed by RojrzTech.',
  },
  hero: {
    badge: 'FITNESS & WELLNESS',
    slides: [
      {
        heading: { pre: 'Scale Your', gold: 'Gym & Fitness', post: 'Business' },
        subheading: 'We design premium gym membership applications, class scheduling platforms, and fitness tracking apps that keep your members motivated and engaged.',
        pills: ['Gym App', 'Class Booking', 'Trainer Portal', 'Membership Sync', 'Personal Plans'],
        image: '/Fitness1.jpeg',
      },
      {
        heading: { pre: 'Interactive', gold: 'Class & Schedule', post: 'Management' },
        subheading: 'Streamline class capacities and trainer schedules with a seamless real-time booking engine that keeps members attending and classes filled.',
        pills: ['Live Schedules', 'Capacity Alerts', 'Calendar Booking', 'Trainer Assign', 'Pass Scan'],
        image: '/Fitness2.jpeg',
      },
      {
        heading: { pre: 'Automated Billing &', gold: 'Membership Portals' },
        subheading: 'Say goodbye to chasing invoices. Our automated billing modules handle subscription renewals, package sign-ups, and merchandise sales.',
        pills: ['Subscription Billing', 'Stripe POS', 'Member Logins', 'Package Sales', 'Analytics'],
        image: '/Fitness.jpeg',
      },
    ],
  },
  showcase: {
    phoneTitle: 'FITNESS COMPANION',
    phoneSubtitle: 'Track member workouts, schedules, and active gym passes.',
    tags: [
      { title: 'Social Media Management', desc: 'Auto-publish member transformations and reels directly to Facebook & Instagram.' },
      { title: 'Local Search Optimization', desc: 'Optimize your gym profile to rank top-3 for local search terms like "gym near me".' },
      { title: 'Member Retention campaigns', desc: 'Automate push alerts and reward milestones to keep your gym members active.' },
      { title: 'Class Schedule Integration', desc: 'Synchronize trainer availability, calendar booking slots, and group fitness schedules.' },
      { title: 'Automated Billing Portal', desc: 'Secure payment gateway processing for memberships, passes, and training sessions.' },
      { title: 'Personalized Workout Plans', desc: 'Let trainers distribute customized diet plans and workout sheets to members.' },
    ],
  },
  videoSection: {
    title: 'Workpays Members App Demonstration',
    subtitle: 'See how our customized member dashboard drives engagement and simplifies operations for gym owners.',
    frameLabel: 'GYM MEMBER MANAGEMENT SYSTEM',
  },
  cards: {
    title: 'Custom Features for Gyms & Fitness Centers',
    subtitle: 'RojrzTech builds interactive fitness systems that reduce member churn, streamline scheduling, and automate recurring revenue.',
    items: [
      {
        icon: '💪',
        title: 'Member Mobile Companion',
        description: 'Provide gym members with iOS and Android applications containing membership barcodes, booking tools, and workout history tracking.',
      },
      {
        icon: '🛒',
        title: 'Subscription Engine',
        description: 'Manage automated monthly recurring dues, contract terms, digital waivers, and one-off class pass payments effortlessly.',
      },
      {
        icon: '⚡',
        title: 'Trainer & Coach Dashboard',
        description: 'Empower personal trainers to manage their client schedules, record performance metrics, and chat with members.',
      },
    ],
  },
  features: {
    title: 'High-Performance Fitness Software Features',
    subtitle: 'Everything you need to run a modern, digital-first fitness facility or group training studio.',
    items: [
      'Member Barcode Scan',
      'Class Schedule Booking',
      'Auto Membership Renewals',
      'Diet & Routine Trackers',
      'Push Notifications',
      'Trainer Assign Logic',
      'In-App Trainer Chat',
      'Point of Sale (POS)',
      'Member Progress Charts',
      'Contract E-Signatures',
      'Facility Capacity Track',
      'Custom Performance Stats',
    ],
  },
};

const Fitness = () => {
  return <IndustryPageTemplate pageData={pageData} />;
};

export default Fitness;
